/* eslint-disable @vp/swan/no-deprecated -- we will need to update to AdaptiveCarousel */
import React from 'react';

import { CarouselSlide, BasicResponsiveImage, Box } from '@vp/swan';
import { useLocalizations } from '@vp/ubik-localizations-provider';

import { buildKeyboardEventHandler } from '../../libs/keyboardEventHandlerBuilder';
import { useResponsiveCloudinaryImage } from '../../libs/useResponsiveCloudinaryImage';

import { ThumbnailMediaSlideProps } from './ThumbnailMediaSlideProps';

export const ThumbnailImageSlide: React.FC<ThumbnailMediaSlideProps> = (props) => {
  const { src, srcSet } = useResponsiveCloudinaryImage(props.slide.thumbnail);
  const { t } = useLocalizations();
  const handleOnClick = () => props.onClickHandler(props.slide.position);

  return (
    <CarouselSlide
      key={props.slide.thumbnailId}
      onClick={handleOnClick}
      aria-label={props.slide.getThumbnailAriaLabel(t)}
    >
      <Box role="button" tabIndex={0} onKeyDown={buildKeyboardEventHandler(handleOnClick)}>
        <BasicResponsiveImage
          aspectRatio={1}
          src={src}
          srcSet={srcSet}
          alt={props.slide.getAlt(t)}
        />
      </Box>
    </CarouselSlide>
  );
};
